module.exports = __webpack_public_path__ + "static/img/17_calm.5a20b6ea.jpg";